import React from "react";
import "./Select.css";
import { LoadingOutlined } from "@ant-design/icons";

function Select(props) {
  const {
    className = "",
    selectClassName = "",
    errors,
    touched,
    id,
    value,
    handleChange,
    placeholder,
    inputBackground,
    labelBackground,
    inputPlaceholder,
    options = [], // garante array vazio
    withNull,
    disabled,
    style,
    multiple,
    loading = false,
  } = props;

  const isDisabled = disabled || loading;

  return (
    <>
      <div
        className={`input-div ${className} rounded flex${
          errors && touched ? " border-danger" : ""
        }`}
        style={{ position: "relative" }}
      >
        <select
          className={`w-100 border-0 ${selectClassName} ${
            isDisabled ? "select-disabled" : ""
          }`}
          id={id}
          value={value}
          onChange={handleChange}
          style={{
            backgroundColor: inputBackground || "white",
            ...style,
          }}
          placeholder={inputPlaceholder}
          disabled={isDisabled}
          multiple={multiple}
        >
          <>
            {withNull && <option value="">{withNull}</option>}
            {options.map((elem) => (
              <option key={elem.value} value={elem.value}>
                {elem.name}
              </option>
            ))}
          </>
        </select>

        <span
          className="span-input"
          style={{
            backgroundColor: labelBackground || "white",
          }}
        >
          {placeholder}
        </span>

        {loading && (
          <span
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "14px",
              color: "#999",
            }}
          >
            <LoadingOutlined />
          </span>
        )}
      </div>
      {errors && touched && <p className="text-danger p-error m-0">{errors}</p>}
    </>
  );
}

export default Select;
